import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {formatBrowseSegmentLabel} from '../shared/browse-seo.utils';

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css', '../shared/listing-browse-ui/rightbar/rightbar.component.scss']
})
export class SidebarComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() urlList;
  @Input() urlName;
  @Output() public sidenavItemToggle = new EventEmitter();

  expandedItems: boolean[] = [];

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.syncExpandedItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['urlList'] || changes['urlName']) {
      this.syncExpandedItems();
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  /** Expand groups that have children so all nav options are reachable. */
  private syncExpandedItems(): void {
    const list = this.urlList || [];
    this.expandedItems = list.map((item: any) => {
      if (!item?.sideBars?.length) {
        return false;
      }
      // Keep the active branch open; also open every group so deep options are visible.
      return true;
    });
  }

  toggleItem(index: number) {
    this.expandedItems[index] = !this.expandedItems[index];
  }

  buildRouterLink(item: any): string[] {
    const segments = ['/'];

    if (item.profile) {
      segments.push(item.profile);
    }
    if (item.url?.categoryUrl) {
      segments.push(item.url.categoryUrl);
    }
    // Legacy motors rows may carry a real itemType; taxonomy fallback used to emit "auto"
    // which must never become a path segment.
    const itemType = item.url?.itemType;
    if (itemType && itemType !== 'auto') {
      segments.push(itemType);
    }
    if (item.url?.subcategoryUrl) {
      segments.push(item.url.subcategoryUrl);
    }
    if (item.url?.subSubcategoryUrl) {
      segments.push(item.url.subSubcategoryUrl);
    }
    if (item.url?.subSubSubcategoryUrl) {
      segments.push(item.url.subSubSubcategoryUrl);
    }
    if (item.url?.subSubSubSubcategoryUrl) {
      segments.push(item.url.subSubSubSubcategoryUrl);
    }
    if (item.url?.subSubSubSubSubcategoryUrl) {
      segments.push(item.url.subSubSubSubSubcategoryUrl);
    }
    if (item.url?.subSubSubSubSubSubcategoryUrl) {
      segments.push(item.url.subSubSubSubSubSubcategoryUrl);
    }
    if (item.url?.subSubSubSubSubSubSubcategoryUrl) {
      segments.push(item.url.subSubSubSubSubSubSubcategoryUrl);
    }
    if (item.url?.subSubSubSubSubSubSubSubcategoryUrl) {
      segments.push(item.url.subSubSubSubSubSubSubSubcategoryUrl);
    }

    const last = segments[segments.length - 1];
    if (last && last !== '/' && last !== 'all' && !String(last).startsWith('all-')) {
      segments.push('all');
    }
    return segments;
  }

  clearSessionStorage() {
    sessionStorage.removeItem('listing_filter_snapshot');
    sessionStorage.removeItem('sectionState');
    sessionStorage.removeItem('selectedItemId');
    sessionStorage.removeItem('displayedItems');
    localStorage.removeItem('listing_form_values');
  }

  getDisplayText(item: any): string {
    return formatBrowseSegmentLabel(this.getLastCategoryName(item));
  }

  /** Optional preview photo when sidebar payload includes one. */
  sidebarImageUrl(item: any): string | null {
    const raw = item?.url?.previewPhoto || item?.url?.photo || item?.previewPhoto;
    if (typeof raw !== 'string') {
      return null;
    }
    const path = raw.trim();
    if (!path || path.includes('<svg')) {
      return null;
    }
    return path;
  }

  isActive(item: any): boolean {
    const lastUrl = this.getLastCategory(item);
    const lastName = this.getLastCategoryName(item);
    return this.urlName === lastUrl || lastName === 'all ' + this.urlName;
  }

  getLastCategory(item: any): string {
    const categories = [
      item.url.subSubSubSubSubSubSubSubcategoryUrl,
      item.url.subSubSubSubSubSubSubcategoryUrl,
      item.url.subSubSubSubSubSubcategoryUrl,
      item.url.subSubSubSubSubcategoryUrl,
      item.url.subSubSubSubcategoryUrl,
      item.url.subSubSubcategoryUrl,
      item.url.subSubcategoryUrl,
      item.url.subcategoryUrl
    ];
    return categories.find(cat => cat) || '';
  }

  getLastCategoryName(item: any): string {
    const names = [
      item.url.subSubSubSubSubSubSubSubcategory,
      item.url.subSubSubSubSubSubSubcategory,
      item.url.subSubSubSubSubSubcategory,
      item.url.subSubSubSubSubcategory,
      item.url.subSubSubSubcategory,
      item.url.subSubSubcategory,
      item.url.subSubcategory,
      item.url.subcategory
    ];
    return names.find(name => name) || '';
  }
}
